import {GvfService} from "../../../gvf/js/gvf-service";
import {FormField} from "../form-field/form-field";

export class FormFieldGeoLocation extends FormField{
    constructor(scope,$root){
        super(scope,$root);
        this.defaultRadius = 1000;
        this.$input = null;
        this.$value = null;
        this.$modal = null;
        this.$modalMap = null;
        this.map = null;
        this.mapMarker = null;
        this.mapArea = null;
        this.useRadius = null;
    }

    gmReady(){
        $(this.scope).each(
            (index,element) => {
                const $field = $(element);
                const input = $field.find(this.scope+"__input").get(0);
                const defaultOptions = {
                    componentRestrictions: { country: [] },
                    fields: ['address_components', 'geometry', 'formatted_address'],
                    types: ['address']
                };
                const options = $field.data("autocomplete-options") || defaultOptions;
                const ac = new google.maps.places.Autocomplete(input,defaultOptions);
                ac.addListener(
                    "place_changed",
                    () => {
                        const place = ac.getPlace();
                        if(place && place.geometry){
                            const value = {};
                            let point = place.geometry.location;
                            if(!point || !point.lat()){
                                point = place.geometry.viewport.getCenter();
                            }
                            value.lat = point.lat();
                            value.lng = point.lng();
                            value.description = place.formatted_address;
                            $field.formFieldSetVal(value);
                        }
                    }
                );
            }
        );
    }

    updateRadius(radius,setRange){
        radius = parseFloat(radius);
        this.mapMarker.radiusVal = radius;
        this.mapArea.setRadius(radius);
        let text = this.mapMarker.radiusVal+" m";
        if(radius>=1000){
            text = (radius/1000).toFixed(1)+" km";
        }
        this.$modal.find(this.scope+"__modal-radius-distance").html(text);
        if(setRange){
            this.$modal.find(this.scope+"__modal-radius-input").val(radius);
        }
    }

    initMap(){
        const options = this.$root.data("map-options");
        if(!this.map){
            this.map = new google.maps.Map(this.$modalMap.get(0),options);
            this.mapMarker = new google.maps.Marker(
                {
                    position: this.map.getCenter(),
                    visible: true,
                    draggable: true
                }
            );
            this.mapMarker.setMap(this.map);

            google.maps.event.addListener(
                this.map,
                "click",
                (ev) => {
                    this.mapMarker.setPosition(ev.latLng);
                }
            );

            if(this.useRadius){
                this.mapArea = new google.maps.Circle(
                    {
                        center: this.map.getCenter(),
                        radius: 2000,
                        fillColor: "#FF0000",
                        fillOpacity: 0.3,
                        strokeColor: "#990000",
                        strokeWidth: 2
                    }
                );
                this.mapArea.setMap(this.map);

                this.$modal.find(this.scope+"__modal-radius-input").on(
                    "change input",
                    (ev) => {
                        this.updateRadius($(ev.currentTarget).val());
                    }
                );

                google.maps.event.addListener(
                    this.mapMarker,
                    "position_changed",
                    () => {
                        this.mapArea.setCenter(this.mapMarker.getPosition());
                    }
                );
            }

            this.$modal.find(this.scope+"__save").click(
                () => {
                    this.$modal.modal("hide");
                    const pos = this.mapMarker.getPosition();
                    const val = {lat: pos.lat(),lng: pos.lng()};
                    if(this.mapMarker.radiusVal){
                        val.radius = this.mapMarker.radiusVal;
                    }

                    const geo = new google.maps.Geocoder;
                    geo.geocode(
                        {"location": this.mapMarker.getPosition()},
                        (results,status) => {
                            if(status==="OK" && results[0]){
                                val.description = results[0].formatted_address;
                            }
                            this.setVal(val);
                        }
                    );
                }
            );
        }

        let position = this.map.getCenter();
        if(this.$value.val()){
            position = JSON.parse(this.$value.val());
            this.map.setCenter(position);
            this.map.setZoom(10);
        }
        this.mapMarker.setPosition(position);
        if(this.useRadius){
            this.updateRadius(position.radius?position.radius:this.defaultRadius,true);
        }
    }

    openModal(){
        this.$modal.modal("show");
        this.initMap();
    }

    getVal(){
        if(this.$value.val()){
            return JSON.parse(this.$value.val());
        }else{
            return null;
        }
    }

    setVal(value,noEvent){
        this.$value.val(value?JSON.stringify(value):"");
        this.$root.toggleClass("has-value",!!this.$value.val());
        this.$modal.modal("hide");
        if(value){
            this.$input.val(value.description?value.description:(value.lat.toFixed(4))+","+value.lng.toFixed(4));
        }else{
            this.$input.val("");
        }
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    ready(){
        super.ready();
        this.$input = this.findMember("input");
        this.$value = this.findMember("value");
        this.$modal = this.findMember("modal").clone().appendTo($("body"));
        this.$modalMap = this.$modal.find(this.scope+"__modal-map");
        this.useRadius = this.$root.data("use-radius");

        this.findMember("empty").click(
            (ev) => {
                ev.preventDefault();
                this.$input.val("");
                this.setVal("");
            }
        );

        this.findMember("search").click(
            (ev) => {
                ev.preventDefault();
                this.openModal();
            }
        );

        this.$input.keypress(
            function(ev){
                if(ev.which==13){
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
        );

        if(this.$value.val()){
            this.setVal(JSON.parse(this.$value.val()),true);
        }

        window._GoogleMapsApi = this;
        window._GoogleMapsApi.gmReady = this.gmReady.bind(this);
        GvfService.loadJsScript("https://maps.googleapis.com/maps/api/js?key="+this.$root.data("gmkey")+"&callback=_GoogleMapsApi.gmReady&libraries=places");
    }
}

